const focusableSelector = 'button, [href], input, select, textarea, li, a,[tabindex]:not([tabindex="-1"])';

let isListenerActive = false;
let lastFocusedElement = null;
let trapFocusSets = [];

const trapFocusListener = (e) => {
    /**
     * Collects first and last focusable elements in container node and moving
     * focus by loop inside the container node while navigation by tab key
     */
    const KEYCODE_TAB = 9;
    const isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

    if (!isTabPressed) {
        return;
    }

    trapFocusSets.forEach((keyNode) => {
        if (keyNode.contains(e.target)) {
            const focusable = keyNode.querySelectorAll(focusableSelector);

            const firstFocusable = focusable[0];
            const lastFocusable = focusable[focusable.length - 1];

            if (e.shiftKey && e.target === firstFocusable) {
                lastFocusable.focus();
                e.preventDefault();
            }

            if (!e.shiftKey && e.target === lastFocusable) {
                firstFocusable.focus();
                e.preventDefault();
            }
        }
    });
};

const a11yService = {
    focusElementWithTimeout(elementId, fallbackElementId) {
        setTimeout(() => {
            const optionsBtn = document.getElementById(elementId);
            if (optionsBtn) {
                optionsBtn.focus();
            } else {
                const fallbackElement = document.getElementById(fallbackElementId || 'optionsMenuButton');
                if (fallbackElement) {
                    fallbackElement.focus();
                }
            }
        }, 100);
    },

    focusElement(elementId) {
        const element = document.getElementById(elementId);
        if (element) {
            element.focus();
        }
    },

    addFocusTrap(containerElement) {
        /**
         * Adds focus trap on the container node:
         * if focus is on any focusable element inside containerElement - navigation
         * with tab key moves focus only inside this container node
         */
        trapFocusSets.push(containerElement);

        if (!isListenerActive) {
            document.addEventListener('keydown', trapFocusListener);
            isListenerActive = true;
        }
    },

    removeFocusTrap(containerElement) {
        /**
         * Removes tracked containers
         * If there are no trackable containers left - removes listener
         */
        const index = trapFocusSets.indexOf(containerElement);
        if (index > -1) {
            trapFocusSets.splice(index, 1);
        }

        if (trapFocusSets.length === 0) {
            document.removeEventListener('keydown', trapFocusListener);
            isListenerActive = false;
        }
    },

    initFocusTrap() {
        /**
         * On esc key - moves focus to last focused element or to first
         * focusable element in document by default
         *
         * Tracks last focused element outside any container node with focus trap
         */
        const listener = (e) => {
            const KEYCODE_TAB = 9;
            const isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

            const KEYCODE_ESC = 27;
            const isEscPressed = (e.key === 'Escape' || e.keyCode === KEYCODE_ESC);

            if (!isTabPressed && !isEscPressed) {
                return;
            }

            if (isEscPressed) {
                this.jumpToLastFocused();

                return;
            }

            for (let i = 0; i < trapFocusSets.length; i++) {
                if (trapFocusSets[i].contains(e.target)) {
                    return;
                }
            }

            lastFocusedElement = e.target;
        };

        document.addEventListener('keydown', listener);
    },

    destroyFocusTrap() {
        trapFocusSets = [];
    },

    jumpToLastFocused() {
        /**
         * Jumps to the last focusable element focused by user
         */
        if (lastFocusedElement) {
            lastFocusedElement.focus();
        } else {
            document.body.querySelector(focusableSelector).focus();
        }
    },
};

export default a11yService;
